import React, { useEffect, useState } from 'react';
import {
    Container,
    Box,
    Typography,
    Grid,
    Card,
    CardContent,
    Link as MuiLink,
    Paper,
    Divider,
    Skeleton,
} from '@mui/material';
import { styled } from '@mui/system';
import Header from './Header';
import Footer from './Footer';
import Navbar from './Navbar';
import { getContactUs } from '../asiosConfig';
import { toast } from 'react-toastify';

const MapWrapper = styled(Box)(({ theme }) => ({
    borderRadius: theme.shape?.borderRadius || 4,
    overflow: 'hidden',
    boxShadow: theme.shadows?.[3] || '0px 3px 6px rgba(0, 0, 0, 0.1)',
    marginBottom: theme.spacing(4),
}));

const ContactCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3),
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
        transform: 'translateY(-5px)',
    },
}));

const ContactUs = () => {
    const [address, setAddress] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchContactUs = async () => {
            try {
                const response = await getContactUs();
                if (response.status === 200 || response.status === 201) {
                    setAddress(response.data.office);
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                toast.error(error.response?.data?.message);
            } finally {
                setLoading(false);
            }
        };
        fetchContactUs();
    }, []);

    return (
        <Box>
            <Navbar />
            <Box mt={12}>
                <Container maxWidth="lg">
                    {/* Header section */}
                    <Box textAlign="center" mb={5}>
                        {loading ? (
                            <Skeleton variant="text" width="40%" height={40} />
                        ) : (
                            <Typography
                                variant="h4"
                                component="h3"
                                gutterBottom
                                sx={{ fontFamily: "Montserrat" }}
                            >
                                IND Matrimony Contact Us
                            </Typography>
                        )}
                        {loading ? (
                            <Skeleton variant="text" width="80%" />
                        ) : (
                            <Typography variant="body1" color="textSecondary">
                                We are here to assist you. Feel free to reach out to us for any inquiries, support, or feedback.
                            </Typography>
                        )}
                    </Box>

                    {/* Google Map Skeleton */}
                    <MapWrapper>
                        {loading ? (
                            <Skeleton variant="rectangular" width="100%" height={450} />
                        ) : (
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4579.932360590312!2d79.0803076!3d21.108429099999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4bf722c40cc11%3A0x82677bbea3008218!2sIND%20Matrimony!5e1!3m2!1sen!2sin!4v1762844284580!5m2!1sen!2sin"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Google Maps Embed"
                            ></iframe>
                        )}
                    </MapWrapper>
                    {/* <Divider variant="middle" sx={{ mb: 2 }} /> */}

                    {/* Contact Details Skeleton */}
                    <Grid container justifyContent="center" alignItems="center" mt={6} mb= {4} >
                        <Grid item xs={12} md={5}>
                            {loading ? (
                                <Skeleton variant="rectangular" width="100%" height={250} />
                            ) : (
                                <Paper elevation={1} sx={{ p: 3, backgroundColor: '#fff', textAlign: 'left' }}>
                                    {address && address.length > 0 && address.map((item, index) => (
                                        <Box key={index} mb={1}>
                                            <Typography variant="body2">
                                                <b>Address:</b> {item.address}
                                            </Typography>
                                            <Typography variant="body2">
                                                <b>Timing:</b> {item.office_time_from} to {item.office_time_to}
                                            </Typography>
                                            <Typography variant="body2">
                                                <b>Phone:</b> {item.mobile_no_1}, {item.mobile_no_2}
                                            </Typography>
                                            <Typography variant="body2">
                                                <b>Email:</b>{' '}
                                                <MuiLink href={`mailto:${item.email}`} color="primary">
                                                    {item.email}
                                                </MuiLink>
                                            </Typography>
                                        </Box>
                                    ))}
                                </Paper>
                            )}
                        </Grid>
                    </Grid>
                    {/* <Divider variant="middle" sx={{ mb: 4 }} /> */}
                </Container>
            </Box>
            <Footer />
        </Box>
    );
};

export default ContactUs;
